<template>
    <a-drawer :title="title" width="1200" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <a-row :gutter="10">
                <a-col :span="9">
                    <a-form-model-item label="模板名称" prop="name">
                        <a-input v-model="field.name" placeholder="请填写证书名称" />
                    </a-form-model-item>
                    <a-form-model-item label="证书级别" prop="grade">
                        <a-radio-group v-model="field.grade" button-style="solid">
                            <template v-for="(val, key) in $enums.CertGrade">
                                <a-radio-button :value="key" :key="key">
                                    {{ val }}
                                </a-radio-button>
                            </template>
                        </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item label="证书类型" prop="type">
                        <a-select v-model="field.type" placeholder="请选择证书类型">
                            <template v-for="(val, key) in $enums.CertType">
                                <a-select-option :value="key" :key="key">
                                    <span>[{{ key.startsWith('UT') ? '机构' : '个人' }}]</span>
                                    {{ val }}
                                </a-select-option>
                            </template>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item label="证书等级" prop="level">
                        <a-input v-model="field.level" placeholder="请填写证书等级" />
                    </a-form-model-item>
                    <a-form-model-item label="发证单位" prop="munit">
                        <a-input v-model="field.munit" placeholder="请填写发证单位" />
                    </a-form-model-item>
                    <a-form-model-item label="有效期" prop="days">
                        <a-radio-group v-model="field.days" button-style="solid">
                            <a-radio-button :value="0">
                                长期有效
                            </a-radio-button>
                            <a-radio-button :value="365">
                                一年
                            </a-radio-button>
                            <a-radio-button :value="730">
                                两年
                            </a-radio-button>
                            <a-radio-button :value="1825">
                                五年
                            </a-radio-button>
                            <a-radio-button :value="3650">
                                十年
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item label="证书样图" prop="imgs">
                        <ImagesUpload type="CertTmplImg" v-if="init" :imgs.sync="field.imgs"></ImagesUpload>
                    </a-form-model-item>
                </a-col>
                <a-col :span="15">
                    <a-form-model-item label="渲染模板" prop="info">
                        <codemirror v-model="field.info" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }"></codemirror>
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>
<style>
.CodeMirror {
    border: 1px solid #eee;
    height: auto;
    min-height: 600px;
    max-height: 700px;
}

.CodeMirror-scroll {
    height: auto;
    min-height: 600px;
    max-height: 700px;
    overflow-y: hidden;
    overflow-x: auto;
}
</style>

<script>
import ImagesUpload from '@/comp/ImagesUpload'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/xml/xml.js'

export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    components: {
        ImagesUpload,
        codemirror
    },
    data() {
        return {
            init: false,
            field: {
                id: '',
                name: '',
                type: 'CT01',
                grade: 'NA',
                level: '',
                munit: '',
                days: 0,
                info: '',
                imgs: ''
            },
            rules: {
                name: [{ required: true, message: '请填写模板名称', trigger: 'blur' }],
                days: [{ required: true, message: '请填写有效期', trigger: 'blur' }],
                type: [{ required: true, message: '请选择证书类型', trigger: 'change' }],
                grade: [{ required: true, message: '请选择证书级别', trigger: 'change' }],
                level: [{ required: true, message: '请选择证书等级', trigger: 'blur' }],
                munit: [{ required: true, message: '请填写发证单位', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        if (this.item.id) {
            this.$http
                .get('/crs/cert/tmpl/detail', {
                    params: {
                        id: this.item.id
                    }
                })
                .then(result => {
                    this.detail = result.data
                    Object.keys(this.field).forEach(key => (this.field[key] = this.detail[key] != undefined ? this.detail[key] : this.field[key] || ''))
                    this.init = true
                })
        } else {
            this.init = true
        }
    },
    methods: {
        doSave() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/crs/cert/tmpl/save', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            if (this.item.id) {
                Object.keys(this.field).forEach(key => (this.field[key] = this.detail[key] != undefined ? this.detail[key] : this.field[key] || ''))
            }
        }
    }
}
</script>
